import tpl from './tpl.tpl';
import '~/style/header.less';

export default function HeaderTpl() {
    const data = {
        nav_left: [
            { id: 'collect', name: "收藏本站", url: "" },
            { id: 'open', name: "免费开户", url: "https://trade.5ifund.com/pc_regnew/regNewInit.action?frm=hd_d3" },
            { id: 'login', name: "安全登录", url: "", pic: "1" },
            { id: '', name: "忘记密码", url: "https://trade.5ifund.com/reg/resetpw/resetpw.html" },
            { id: 'app', name: "手机客户端", url: "/public/0703appdownload-pc/index-pc.htm#agdresetpw.html" }
        ],
        nav_right: [
            { id: 'nav', name: "网站导航", url: '' },
            { id: '', name: "服务中心", url: '/introduce/service.shtml' },
            { id: '', name: "自选基金", url: '/zixuan/index.html' },
            { id: 'product', name: "产品导购", url: '/market/xuangou/', pic: "1" },
            { id: 'fundbus', name: "基金交易", url: 'https://trade.5ifund.com/login/loginInit.action?frm=ijijin', pic: "1" },
            { id: 'backindex', name: "返回同花顺理财", url: '/' }
        ],
        nt_login: [
            {
                class: "login",
                top: '交易登录',
                bottom: '申购费率0折',
                url: 'https://trade.5ifund.com/login/loginInit.action?frm=ijijin'
            },
            {
                class: "open",
                top: '免费开户',
                bottom: '8秒快速开户',
                url: 'https://trade.5ifund.com/pc_regnew/regNewInit.action?frm=hd_d3'
            }
        ],
        nt_deal: [
            { desc: '收益宝', url: '/syb/?frm=ijijin_icon_syb' },
            { desc: '理财宝', url: '/public/dqlc/?frm=ijijin' },
            { desc: '购买基金', url: 'https://trade.5ifund.com/pc/buy.html' },
            { desc: '定投基金', url: 'https://trade.5ifund.com/pc/plan.html' }
        ],
        nt_guide: [
            { desc: '基金超市', url: '/market/' },
            { desc: '热销基金', url: '/market/rexiao/' },
            { desc: '新发基金', url: '/market/xfx/' },
            { desc: '基金定投', url: '/market/dingtou/' }
        ],
        grade: [
            { desc: '我的自选', url: '/zixuan/index.html' },
            { desc: '基金经理', url: '/datacenter/manager/' },
            { desc: '基金主题', url: '/fundtheme/index.html' },
            { desc: '基金学院', url: '/jjbk_list/' },
            { desc: '基金比较', url: 'http://tools.fund.10jqka.com.cn/compare/' },
            { desc: '收益计算', url: 'http://tools.fund.10jqka.com.cn/calculator/single.html' },
            { desc: '基金观点', url: '/jjpl_list/' },
            { desc: '基金研究', url: '/jjyj_list/' }
        ],
        grade2: [
            { desc: '基金净值', url: '/datacenter/jz/' },
            { desc: '基金排行', url: '/datacenter/sy/' },
            { desc: '基金估值', url: '/datacenter/jjgz/' },
            { desc: '基金分红', url: '/datacenter/fh/' },
            { desc: '基金拆分', url: '/datacenter/jjcf/' },
            { desc: '新发基金', url: '/datacenter/xfjj/' },
            { desc: '基金定投', url: '/datacenter/dt/' },
            { desc: '基金公司', url: '/datacenter/jjgspm/' }
        ],
        grade3: [
            { desc: '收益宝', url: '/syb/?frm=ijijin_icon_syb' },
            { desc: '理财宝', url: '/public/dqlc/' },
            { desc: '基金超市', url: '/market/' },
            { desc: '热销基金', url: '/market/rexiao/' },
            { desc: '新发基金', url: '/market/xfx/' },
            { desc: '基金定投', url: '/market/dingtou/' },
            { desc: '基金选购', url: '/market/xuangou/' },
            { desc: '一折优惠', url: '/public/yizhe/discount.html' }
        ]
    };
    return {
        tpl: tpl(data)
    };
}